// 1 - простой от 0 до 4-х часов,
// 2 - простой от 4-х до 10-и частов,

import { ACTIVE_STATUS } from "shared/constants/obu";

// 3 - простой больше 10-и часов
export const checkIsIdleFrom0To4Hours = (status: number) =>
  status === ACTIVE_STATUS.FROM_0_TO_4_HOURS;

export const checkIsIdleFrom4To10Hours = (status: number) =>
  status === ACTIVE_STATUS.FROM_4_TO_10_HOURS;

export const checkIsIdleFrom10 = (status: number) =>
  status === ACTIVE_STATUS.MORE_10;
